export default __webpack_public_path__ + "static/media/swag3.fa4e5297.jpg";